import { BreadCrumDataType } from './SEOMetaTypes';
import { DynamicObject } from '../../utils/commonTypes';
import { getURL } from '../../utils/OGTags';

export const breadCrumbFilter = (
  breadcrumbs: BreadCrumDataType[],
  countryCode: string,
  displayLanguage: string,
  consumptionPageTranslations: DynamicObject
) => {
  const breadcrumbStrings = consumptionPageTranslations?.BREADCRUMB;
  const homeUrl = getURL(countryCode, displayLanguage, '/');
  const breadcrumbsClone = [{ label: breadcrumbStrings?.HOME, url: homeUrl }];
  breadcrumbs.forEach((item) => {
    const url = getURL(countryCode, displayLanguage, item.url);
    const itemData = { label: item.label, url };
    breadcrumbsClone.push(itemData);
  });
  return breadcrumbsClone;
};
